import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Googletag } from 'shared/modules';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import { generateDealersSearchUrl } from 'shared/helpers/urls';
import * as formActions from 'shared/actions/searchForm';
import InlineNav from 'desktop/components/InlineNav/InlineNav';
import PageTitle from 'desktop/components/PageTitle/PageTitle';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import TopAvtosalon from 'desktop/components/TopAvtosalon/TopAvtosalon';
import Paginate from 'desktop/components/Paginate/Paginate';
import DealersList from './components/DealersList';
import SearchBar from './components/SearchBar';
import s from './Dealers.css';

class Dealers extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    transportType: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formResults: PropTypes.shape().isRequired,
    query: PropTypes.shape().isRequired,
    queryParams: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    count: PropTypes.number,
    location: PropTypes.shape(),
    transportLinks: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    topDealerRequestObj: PropTypes.shape(),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  };

  static defaultProps = {
    topDealer: null,
    count: 0,
    location: null,
    topDealerRequestObj: {},
    seoQuery: {},
  };

  render() {
    const {
      url,
      queryParams,
      currentPage,
      transportType,
      formData,
      formState,
      formResults,
      formVocabulary,
      selectedActions,
      query,
      count,
      transportLinks,
      title,
      location,
      topDealerRequestObj,
    } = this.props;

    const result =
      url === '/avtosalony/' &&
      queryParams !== 'currency=uah&transport=1' &&
      formResults &&
      formResults[`dealers-currency=uah&transport=1`]
        ? formResults[`dealers-currency=uah&transport=1`]
        : formResults[`dealers-AJAX`] || {};

    const pageCount = Math.ceil(count / 20);

    const linkPrefix = generateDealersSearchUrl({ transport: transportType });

    // /avtosalony/ === /avtosalony/avto/
    const currentUrl =
      transportType.id === 1 ? `/${generateDealersSearchUrl({})}/avto/`.replace(/\/\//g, '/') : url;
    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <div className={s.navWrapper}>
                <InlineNav currentRoute={currentUrl} navLinks={transportLinks} including />
              </div>
              <SearchBar
                transportType={transportType}
                selectedActions={selectedActions}
                formState={formState}
                formData={formData}
                formVocabulary={formVocabulary}
              />
              <div className={s.advertContainerGl}>
                <Googletag id="div-gpt-ad-1510239331518-2" />
              </div>
              <PageTitle title={title} />
              <DealersList dealers={result.results} />
              {pageCount > 1 && (
                <Paginate query={query} url={url} pageCount={pageCount} initialPage={currentPage} />
              )}
            </div>
            <DesktopRightSidebar>
              <React.Fragment>
                <TopAvtosalon
                  key={JSON.stringify(topDealerRequestObj)}
                  additionParams={topDealerRequestObj}
                />
                <MakesSidebar />
              </React.Fragment>
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  formState: searchForm && searchForm.selected,
  formResults: searchForm && searchForm.results,
  formData: searchForm && searchForm.data,
  formVocabulary: searchForm && searchForm.vocabulary,
  location: globals && globals.location,
  count: searchForm.data.count,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.dealersSetThunks,
      },
      dispatch,
    ),
    toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
    clear: bindActionCreators(formActions.selectedActions.clear),
    clearForm: bindActionCreators(formActions.dealersSetThunks.clearSelected, dispatch),
  },
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Dealers),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/dealers/Dealers.js